import styled from 'styled-components';
import watermark from '../../assets/images/watermark.svg';

export const Modal = styled.section`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.grey[800]};
  z-index: 7;

  @media ${({ theme }) => theme.devices.tablet} {
    padding: 0px !important;
  }

  &::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background: ${({ theme }) => theme.colors.gradient[180]};
    opacity: 0.5;
    z-index: -1;
  }

  &::after {
    content: '';
    position: absolute;

    transform: translateY(30%) translateX(20%);
    inset: 0;
    background-image: url(${watermark});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.2;
    pointer-events: none;
    z-index: -1;
  }
`;

export const Container = styled.section`
  width: 100%;
  max-width: 600px;
  padding: 2%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${({ theme }) => theme.devices.tablet} {
    position: relative;
    padding: 0;
  }
`;

export const Header = styled.header`
  width: 80%;
  padding: 8px 0;
  position: relative;
  display: flex;
  align-items: center;
  z-index: 2;

  h4 {
    margin-left: 48px;
  }

  @media ${({ theme }) => theme.devices.tablet} {
    gap: 4px;

    h3 {
      font-size: 24px;
    }
  }
`;

export const ProfileImg = styled.div`
  width: 100%;
  max-width: 68px;
  height: 68px;

  position: absolute !important;
  /* top: -50%; */
  transform: translateY(8%) translateX(-40%);

  border-radius: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  overflow: hidden;

  &::after {
    width: 100%;
    height: 100%;
    position: absolute;
    content: '';

    background-image: url(${({ $profile }) => $profile});
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
`;

export const ButtonClose = styled.button`
  display: flex;
  position: absolute;
  right: 2%;
  top: 2%;
  color: ${({ theme }) => theme.colors.grey.white};
  background-color: transparent;
  border: 0;
  z-index: 3;

  svg {
    width: 48px;
    height: 48px;
    transform: rotate(45deg);
  }
`;

export const GroupImg = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  > button {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    background-color: transparent;
    padding: 4px;
    border-radius: 100%;
    overflow: hidden;
    border: 0;
    z-index: 2;

    svg {
      width: 36px;
      height: 36px;
      color: ${({ theme }) => theme.colors.grey.white};
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: ${({ theme }) => theme.colors.grey.white};
      opacity: 0.2;
      z-index: -1;
    }

    :hover {
      opacity: 0.7;
    }
  }

  .right {
    top: 50%;
    transform: translateY(-50%) translateX(100%);
    right: -4px;
  }

  .left {
    top: 50%;
    transform: translateY(-50%) translateX(-100%);
    left: -4px;
  }
`;

export const WrapMidia = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url(${watermark});
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.6;
    pointer-events: none;
    z-index: 1;
  }

  video,
  img {
    width: 100%;
    object-fit: contain;
    border-radius: 24px;
    border: 1px solid ${({ theme }) => theme.colors.primary.main};
  }
`;

export const Controls = styled.div`
  width: fit-content;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  gap: 16px;
  z-index: 1;

  button {
    display: flex;
    background: rgba(0, 0, 0, 0.6);
    border: none;
    padding: 12px;
    border-radius: 50%;
    color: white;
    cursor: pointer;

    svg {
      width: 32px;
      height: 32px;
    }
  }
`;

export const BottomButtons = styled.footer`
  width: 80%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 8px;
  gap: 20px;

  b {
    font-weight: 700;
  }
`;

export const Button = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 12px;
  background-color: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.grey.white};

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 16px;
    background: ${({ $active, theme }) =>
      $active ? theme.colors.gradient.fullX : theme.colors.grey.white};
    opacity: 0.3;
    z-index: -2;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    padding: 2px;
    border-radius: 16px;
    background: ${({ $active, theme }) =>
      $active ? theme.colors.gradient.fullX : theme.colors.grey.white};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
    z-index: -1;
  }

  &:hover {
    transition: 0.7s;

    &::before {
      transition: 0.7s;
      opacity: 0.5;
    }
  }

  span {
    font-weight: ${({ $active }) => ($active ? '700' : '300')};
  }
`;
